import { useState } from "react";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function ChangeEmailCard() {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ new_email: "", current_password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-email", f);
      setUser(data);
      setF({ new_email: "", current_password: "" });
      toast.success(`Sign-in email changed to ${data.email}`);
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <section className="rounded-2xl border bg-white p-6 sm:p-7" data-testid="change-email-card">
      <div className="flex items-center gap-2 mb-1">
        <Mail className="h-4 w-4 text-primary" />
        <h2 className="text-lg font-semibold">Sign-in email</h2>
      </div>
      <p className="text-sm text-slate-500 mb-5">
        Currently <b data-testid="current-email">{user.email}</b>. Use an inbox you check — password reset links are sent here.
      </p>
      <form onSubmit={submit} className="grid sm:grid-cols-2 gap-4 items-end">
        <div className="space-y-1.5">
          <Label htmlFor="ce-email">New email</Label>
          <Input id="ce-email" type="email" required value={f.new_email} onChange={(e) => setF({ ...f, new_email: e.target.value })} className="h-10" data-testid="change-email-new-input" />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="ce-pass">Current password</Label>
          <Input id="ce-pass" type="password" autoComplete="current-password" required value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} className="h-10" data-testid="change-email-password-input" />
        </div>
        <div className="sm:col-span-2">
          <Button type="submit" className="rounded-full px-6" disabled={busy} data-testid="change-email-submit-button">
            {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Update email
          </Button>
        </div>
      </form>
    </section>
  );
}
